import React from "react"
import { baseColors, baseFontFamily } from "@Constants/baseStyles"
import { createMaterialTopTabNavigator } from "@react-navigation/material-top-tabs"
import { RFValue } from "react-native-responsive-fontsize"
import ForumStack from "./ForumStack/ForumStack"
import TeamParole from "@Screens/Knowledge/SavoirEtre/TeamParole/TeamParole"
import Forum from "@Screens/Knowledge/SavoirEtre/Forum/Forum"

const Tab = createMaterialTopTabNavigator()

const SavoirEtreTopTabStack = () => {
    const screens = [
        {
            tabBarLabel: "Groupe de parole",
            name: "TeamParole",
            component: TeamParole
        },
        {
            tabBarLabel: "Forum",
            name: "Forum",
            component: Forum
        }
    ]

    const screenOptions = {
        tabBarPressColor: baseColors.green.primary,
        tabBarActiveTintColor: baseColors.green.primary,
        tabBarInactiveTintColor: baseColors.black,
        tabBarScrollEnabled: true,
        tabBarItemStyle: { width: "auto" },
        tabBarLabelStyle: {
            fontSize: 14,
            fontFamily: baseFontFamily.OpenSansBold
        },
        tabBarIndicatorStyle: { backgroundColor: baseColors.green.primary, height: 4 }
    }

    return (
        <Tab.Navigator screenOptions={screenOptions}>
            {screens.map((item, i) => (
                <Tab.Screen
                    key={i}
                    name={item.name}
                    options={{ tabBarLabel: item.tabBarLabel }}
                    component={item.component}
                />
            ))}
        </Tab.Navigator>
    )
}

export default SavoirEtreTopTabStack
